import './App.css';
import { Navigate, Route, Routes } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { Box, CircularProgress } from '@mui/material';
import Footer from './Components/Footer';
import RootLayout from './layouts/RootLayout';
import Poe1Layout from './layouts/Poe1Layout';
import Poe2Layout from './layouts/Poe2Layout';
import Home from './pages/Home';
import MapMod from './pages/MapMod';
import SaveList from './pages/SaveList';
import Guide from './pages/Guide';
import RegexTrans from './pages/RegexTrans';

const DDalGGak = lazy (() => import('./pages/DDalGGak'));
const WaystoneRegex = lazy (() => import('./poe2/waystoneRegex/WaystoneRegex'));
const TabletRegex = lazy (() => import('./poe2/tabletRegex/TabletRegex'));
const Scarabs = lazy (() => import('./pages/Scarabs'));
const Beasts = lazy (() => import('./pages/Beasts'));
const Tattoo = lazy (() => import('./pages/Tattoo'));
const Rune = lazy (() => import('./pages/Rune'));
const Oil = lazy (() => import('./pages/Oil'));
const UpdateNote = lazy (() => import('./pages/UpdateNote'));
const BugReport = lazy (() => import('./pages/BugReport'));
const BugReportAdmin = lazy (() => import('./pages/BugReportAdmin'));
const Challenges = lazy (() => import('./pages/Challenges'));
const Ultimatum = lazy (() => import('./pages/Ultimatum'));
const Voyage = lazy (() => import('./voyage/Voyage'));
const Dust = lazy (() => import('./pages/Dust'));
const Siosa = lazy (() => import('./pages/Siosa'));

function App() {

  return (
    <div className='app-shell'>
      <div className="app-content">
        <Suspense fallback={
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
            <CircularProgress />
          </Box>
        }>
          <Routes>
            <Route element={<RootLayout />}>
              <Route path='/' element={<Home />} />
            </Route>
            <Route element={<Poe1Layout />}>
              <Route path='/map' element={<MapMod />} />
              <Route path='/savelist' element={<SaveList />} />
              <Route path='/guide' element={<Guide />} />
              <Route path='/trans' element={<RegexTrans />} />
              <Route path='/scarabs' element={<Scarabs />} />
              <Route path='/beast' element={<Beasts />} />
              <Route path='/tattoo' element={<Tattoo />} />
              <Route path='/rune' element={<Rune />} />
              <Route path='/oil' element={<Oil />} />
              <Route path='/ddalggak' element={<DDalGGak />} />
              <Route path='/update' element={<UpdateNote />} />
              <Route path='/bugreport' element={<BugReport />} />
              <Route path='/bugreport/admin' element={<BugReportAdmin />} />
              <Route path='/challenges' element={<Challenges />} />
              <Route path='/ultimatum' element={<Ultimatum />} />
              <Route path='/voyage' element={<Voyage />} />
              <Route path='/dust' element={<Dust />} />
              <Route path='/siosa' element={<Siosa />} />
            </Route>
            <Route element={<Poe2Layout />}>
              <Route path='/poe2/map' element={<WaystoneRegex />} />
              {/* 구 경로 즐겨찾기 대응: /poe2/regex -> /poe2/map */}
              <Route path='/poe2/regex' element={<Navigate to="/poe2/map" replace />} />
              <Route path='/poe2/tablet' element={<TabletRegex />} />
              <Route path='/poe2/savelist' element={<SaveList version="poe2" />} />
            </Route>
          </Routes>
        </Suspense>
      </div>
      <Footer />
    </div>
  );
}

export default App;
